module.exports = __webpack_public_path__ + "img/background.183c0d2.svg";